import React from 'react';

const FeaturePost = ({ post, index }) => {
  return (
    <div className="modern-login-feature-post">
      <div className="modern-login-post-header">
        <div className="modern-login-post-avatar-wrapper">
          <img
            src={post.url}
            alt="Creator"
            className="modern-login-post-avatar"
          />
        </div>
        <div className="modern-login-post-info">
          <div className="modern-login-post-username">@{post.name.toLowerCase()}</div>
          <p className="modern-login-post-content">
            {post.content}
          </p>
        </div>
        <div className="modern-login-post-time">{post.time}</div>
      </div>

      <div className="modern-login-post-actions">
        <div className="modern-login-post-action-buttons">
          <button className="modern-login-post-action-btn">
            <i className="fas fa-heart"></i>
            <span>{index === 0 ? '1.2k' : '892'}</span>
          </button>
          <button className="modern-login-post-action-btn">
            <i className="fas fa-dollar-sign"></i>
            <span>Tip</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeaturePost;
